const companyInformation = [
    { label: "Founded", value: "2021" },
    { label: "Employees", value: "20" },
    { label: "Happy Customers", value: "5" },
    // { label: "Raised", value: "$25M" },
];

export default companyInformation;